import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PageShell } from "../components/layout/PageShell";
import { WORLD } from "../data/siteContent";

export default function GarysWorld() {
  return (
    <PageShell>
      <section data-testid="world-page" className="relative pt-36 md:pt-44 pb-16 overflow-hidden grain">
        <div className="aurora-weave" />
        <div className="line-weave" />
        <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 text-center">
          <p className="text-sm tracking-[0.24em] uppercase text-[#E7CC86]/80 mb-4">{WORLD.eyebrow}</p>
          <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-cream mb-5">
            One ecosystem. <span className="text-gold">Many worlds.</span>
          </h1>
          <p className="text-lg text-cream/70 max-w-2xl mx-auto">{WORLD.sub}</p>
        </div>
      </section>

      <section className="relative py-10 md:py-16 bg-[#0B1020]">
        <div className="max-w-6xl mx-auto px-5 md:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {WORLD.properties.map((p, i) => (
              <motion.div key={p.title}
                initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}>
                <Link to={p.to} data-testid={`world-card-${i}`} className="group relative block rounded-2xl overflow-hidden h-72">
                  <img loading="lazy" src={p.img} alt={p.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#080B12] via-[#080B12]/50 to-transparent" />
                  <div className="absolute inset-0 flex flex-col justify-end p-7">
                    <h2 className="font-display text-2xl text-cream mb-2 flex items-center gap-2">
                      {p.title} <ArrowUpRight size={18} className="text-[#E7CC86] opacity-0 group-hover:opacity-100 group-hover:translate-x-0.5 transition-all" />
                    </h2>
                    <p className="text-cream/70 text-sm leading-snug">{p.note}</p>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}
